(() => {
  if (window.radianceMotion) return;
  const instances = new Map();
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = window.matchMedia('(min-width: 1000px)');
  let frame = 0;
  const permitted = () => document.body.dataset.qrMotion !== 'false' && !preference.matches && !window.Shopify?.designMode;
  const update = () => {
    frame = 0;
    if (!permitted() || !desktop.matches) return;
    instances.forEach(instance => {
      if (!instance.active || !instance.depth) return;
      const bounds = instance.element.getBoundingClientRect();
      const progress = Math.max(-1, Math.min(1, (window.innerHeight / 2 - bounds.top - bounds.height / 2) / window.innerHeight));
      instance.element.style.setProperty('--qr-orbit', `${(progress * 9).toFixed(2)}deg`);
      instance.images.forEach(image => {
        image.style.setProperty('--qr-shift', `${(progress * instance.depth).toFixed(2)}px`);
        image.style.setProperty('--qr-scale', '1.06');
      });
    });
  };
  const schedule = () => { if (!frame && permitted() && desktop.matches) frame = requestAnimationFrame(update); };
  const destroy = element => {
    const instance = instances.get(element);
    if (!instance) return;
    instance.observer?.disconnect();
    instance.element.style.removeProperty('--qr-orbit');
    instance.animations.forEach(animation => animation.cancel());
    instance.images.forEach(image => { image.style.removeProperty('--qr-shift'); image.style.removeProperty('--qr-scale'); });
    instances.delete(element);
  };
  const mount = element => {
    if (instances.has(element) || !permitted() || element.dataset.careMotion === 'false' || !('IntersectionObserver' in window)) return;
    const instance = { element, active: false, depth: Number(element.dataset.careDepth) || 0, images: [...element.querySelectorAll('.care-hero-image img,.care-picture:not(.care-picture--original) img')], animations: [] };
    instances.set(element, instance);
    const revealed = new WeakSet();
    const duration = document.body.dataset.qrPace === 'quick' ? 460 : 760;
    const targets = element.matches('.care-hero-banner') ? [] : [...element.querySelectorAll('.care-heading,.care-benefit,.care-card,.care-story-media,.care-story-content>.care-copy,.care-story-point,.care-mini-product,.care-faq-list')];
    instance.observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.target === element) { instance.active = entry.isIntersecting; schedule(); continue; }
        if (!entry.isIntersecting || revealed.has(entry.target)) continue;
        revealed.add(entry.target);
        instance.observer.unobserve(entry.target);
        if (typeof entry.target.animate !== 'function') continue;
        instance.animations.push(entry.target.animate([{ opacity: .35, transform: 'translateY(22px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration, easing: 'cubic-bezier(.2,.7,.2,1)' }));
      }
    }, { threshold: 0, rootMargin: '0px 0px -32px 0px' });
    instance.observer.observe(element);
    targets.forEach(target => instance.observer.observe(target));
  };
  const init = root => root.querySelectorAll('[data-care-motion]').forEach(mount);
  const reset = () => { [...instances.keys()].forEach(destroy); init(document); };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => [...instances.keys()].filter(element => event.target.contains(element)).forEach(destroy));
  preference.addEventListener('change', reset);
  desktop.addEventListener('change', reset);
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.radianceMotion = { init, reset };
  init(document);
})();
